import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.scss'],
  imports: [MatIcon]
})
export class InfoMessageComponent {
  isChrome = window.navigator.vendor === 'Google Inc.' && window.navigator.userAgent.indexOf('Edg') >= -1;
  constructor() {}
}
